/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unsupported_Video_FormatInputs */

const en_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsupported video format`)
};

const es_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de video no compatible`)
};

const fr_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format vidéo non pris en charge`)
};

const de_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht unterstütztes Videoformat`)
};

const ja_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートされていないビデオ形式`)
};

const zh_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不支持的视频格式`)
};

const ar_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صيغة فيديو غير مدعومة`)
};

const id_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format video tidak didukung`)
};

const it_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato video non supportato`)
};

const ru_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неподдерживаемый формат видео`)
};

const pt_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de vídeo não suportado`)
};

const ko_unsupported_video_format = /** @type {(inputs: Unsupported_Video_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원되지 않는 비디오 형식`)
};

/**
* | output |
* | --- |
* | "Unsupported video format" |
*
* @param {Unsupported_Video_FormatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unsupported_video_format = /** @type {((inputs?: Unsupported_Video_FormatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unsupported_Video_FormatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unsupported_video_format(inputs)
	if (locale === "es") return es_unsupported_video_format(inputs)
	if (locale === "fr") return fr_unsupported_video_format(inputs)
	if (locale === "de") return de_unsupported_video_format(inputs)
	if (locale === "ja") return ja_unsupported_video_format(inputs)
	if (locale === "zh") return zh_unsupported_video_format(inputs)
	if (locale === "ar") return ar_unsupported_video_format(inputs)
	if (locale === "id") return id_unsupported_video_format(inputs)
	if (locale === "it") return it_unsupported_video_format(inputs)
	if (locale === "ru") return ru_unsupported_video_format(inputs)
	if (locale === "pt") return pt_unsupported_video_format(inputs)
	return ko_unsupported_video_format(inputs)
});